import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Params } from '@angular/router';
import { MatLegacyMenuTrigger as MatMenuTrigger } from '@angular/material/legacy-menu';
import { RoutingService } from 'src/app/service/routing.service';
import { FeatureFlagsService } from 'src/app/shared/services/customer-api/feature-flags.service';
import { UserActivityApiService } from 'src/app/shared/services/customer-api/user-activity-api.service';
import { BreakpointService } from 'src/app/shared/services/breakpoints.service';
import { NewsFeedProcessorService } from '../news-feed-processor.service';
import { NewsfeedDisplaySettingsService } from '../../services/newsfeed-display-settings.service';
import { NewsArticle } from '../../news-newsfeed-interface/news-feed.interfaces';

export interface NewsSelection {
  news: NewsArticle;
  type: string;
}

@Component({
  selector: 'app-news-feed-list',
  templateUrl: './news-feed-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewsFeedListComponent {
  @Input() newsfeed: NewsArticle[] = [];
  @Input() params: Params = {};
  @Input() newstype: string;
  @Input() stars: string[] = [];
  @Input() loadnews: string | number;
  @Input() fullscreen: boolean;

  @Output() newsSelected = new EventEmitter<NewsSelection>();
  @Output() bookmarkToggled = new EventEmitter<string>();

  screenSize$ = this.breakpointService.screenSize$;
  displaySettings$ = this.displaySettingsService.getSettings();

  private inMenu = false;
  private inButton = false;

  constructor(
    public routing: RoutingService,
    public featureFlagsService: FeatureFlagsService,
    public userActivityApi: UserActivityApiService,
    private breakpointService: BreakpointService,
    private displaySettingsService: NewsfeedDisplaySettingsService,
    private feedProcessor: NewsFeedProcessorService,
  ) {}

  selectNews(news: NewsArticle, type: string): void {
    this.newsSelected.emit({ news, type });
  }

  toggleBookmark(newsId: string): void {
    this.bookmarkToggled.emit(newsId);
  }

  iBookmark(id: string): boolean {
    return this.stars.includes(id);
  }

  getTeaser(news: NewsArticle): string | undefined {
    return this.feedProcessor.getTeaser(news, this.params);
  }

  checkTimeframe(): boolean {
    return this.feedProcessor.checkTimeframe(this.params);
  }

  onMouseEnter(trigger: MatMenuTrigger, element: string): void {
    if (element === 'button') {
      this.inButton = true;
      setTimeout(() => {
        if (this.inButton) {
          trigger.openMenu();
        }
      }, 200);
    } else {
      this.inMenu = true;
    }
  }

  onMouseLeave(trigger: MatMenuTrigger, element: string): void {
    if (element === 'button') {
      this.inButton = false;
      setTimeout(() => {
        if (!this.inMenu) {
          trigger.closeMenu();
        }
      }, 400);
    } else {
      this.inMenu = false;
      trigger.closeMenu();
    }
  }

  onMouseEnterRow(item: NewsArticle): void {
    item.visible = true;
  }

  onMouseLeaveRow(item: NewsArticle): void {
    item.visible = false;
  }
}
